import React, { useEffect, useRef, useState } from 'react'
import './DropdownSelect.css'

const DropdownSelect = ({options,setFilter,onlySelectFunction = false,placeholder}) =>{

    const [showDropdown,setShowDropdown] = useState(false);
    const [inputValue,setInputValue] = useState('');
    const [value,setValue] = useState({});
    const [highlightedIndex,setHighlightedIndex] = useState(-1);
    const inputRef = useRef(null);
    const listRef = useRef([]);
    const [optionsFiltered,setOptionsFiltered] = useState(options);

    
    const handleInputFocus = () =>{
        if(onlySelectFunction){ //Define como se comporta el componente.
            setOptionsFiltered(options);
        }
        setHighlightedIndex(-1); //Es necesario setearlo a -1 ya que en caso que haya quedado naranja y por texto solo se filtre manzana se hace imposible utilizar las flechas.
        setShowDropdown(true);
    }

    const handleChange = (e) => {
        setHighlightedIndex(-1); //Es necesario setearlo a -1 independientemente del valor del input ya que cuando queda una opcion seleccionada entre las no filtradas las flechas no funcionan correctamente.
        if(e.target.value == ''){
            setInputValue('');
            setValue({});
            setOptionsFiltered(options);
            setFilter(''); //Setea estado del componente padre para filtrar lista de OPs y RGs.
        }else{
            setFilter(e.target.value); //Setea estado del componente padre para filtrar lista de OPs y RGs.
            setInputValue(e.target.value);
            let newOptions = (e.target.value != '') ? options.filter((option) => option.label.toLowerCase().includes(e.target.value.toLowerCase())) : options;
            setOptionsFiltered(newOptions);
        }
    }

    const handleOptionClick = (option) =>{
        setInputValue(option.label);
        setValue(option);
        setFilter(option.label); //Setea estado del componente padre para filtrar lista de OPs y RGs.
        setOptionsFiltered([option]);
        setShowDropdown(false);
        inputRef.current.blur();
    }

    const handleKeyDown = (e) =>{
        if(e.key === 'ArrowDown'){
            setHighlightedIndex((prevIndex) => {
                e.preventDefault();
                const nextIndex = prevIndex < optionsFiltered.length - 1 ? prevIndex + 1 : prevIndex;
                listRef.current[nextIndex]?.scrollIntoView({block: 'nearest'});
                return nextIndex;
            });

        } else if(e.key === 'ArrowUp'){
            setHighlightedIndex((prevIndex) => {
                e.preventDefault();
                const nextIndex = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                listRef.current[nextIndex]?.scrollIntoView({block: 'nearest'});
                return nextIndex;
            });
        }
        if(e.key === 'Enter'){
            if(highlightedIndex >= 0 && highlightedIndex < optionsFiltered.length){
                handleOptionClick(optionsFiltered[highlightedIndex]);
            }
        }
        if(onlySelectFunction && e.key === 'Backspace'){ //Si onlySelectFunction == true, funciona solo como un listado con opciones, y tecla Backspace == true !NO BORRA NADA!
            e.preventDefault();
        }
    }

    const handleClickOutside = (e) =>{
        //Comprueba que no se hace click ni en el input ni en las opciones del mismo.
        if(inputRef.current && !inputRef.current.contains(e.target) && e.target.localName != 'li'){ 
            setShowDropdown(false);
            inputRef.current.blur();
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return <div className='dropdownSelectDiv'>
        <div className='inputGroup'>
            <input ref={inputRef} value={inputValue} onFocus={handleInputFocus} onKeyDown={(e) => handleKeyDown(e)} onChange={(e)=>handleChange(e)} placeholder={/*(Object.keys(value).length == 0) && 'Select...'*/ placeholder } className={'inputFilter'}/>
        </div>
        {showDropdown && <ul>
            {optionsFiltered.map((option,index) => <li key={index} ref={(el) => (listRef.current[index] = el)} id={(index == optionsFiltered.length - 1 ) ? 'lastOption' : (index == 0) && 'firstOption'} className={highlightedIndex == index ? 'highlightedOption' : `option`}onClick={()=> handleOptionClick(option)}>{option.label}</li>)}
        </ul>}
    </div>
}

export default DropdownSelect;